import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CrmsettingsService } from './crmsettings.service';
import { EcryptServiceService } from './ecrypt-service.service';

@Injectable({
  providedIn: 'root'
})
export class WhatsappcontactService {

  url = environment.serverAPI8 + "/api/contacts";
  url2 = environment.serverAPI8 + "/api";
  crmSettingsData: any;
  whatsappVendorId: any;

  constructor(private http: HttpClient, private crmsettingsService: CrmsettingsService,
    private ecryptService: EcryptServiceService) { }

  getAllWhatsappcontact(Page: any, size: any, sort: any): Observable<Object> {

    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

    }

    let params = new HttpParams();


    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllWhatsappcontactDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getWhatsappcontactById(id: number): Observable<Object> {
    let params = new HttpParams();
    // if (vendorId !== null && vendorId !== undefined) {
    //   params = params.set('vendorId', vendorId);
    // }

    return this.http.get(`${this.url}/${id}`);
  }
  getWhatsappContactDataById(id: number): Observable<Object> {
    let params = new HttpParams();
    // if (vendorId !== null && vendorId !== undefined) {
    //   params = params.set('vendorId', vendorId);
    // }

    return this.http.get(`${this.url}/by/${id}`);
  }
  deleteContact(contactuuid: string): Observable<any> {
    return this.http.delete(`${this.url}/${contactuuid}/delete-process`);
  }

  deleteAllContacts(): Observable<any> {
    return this.http.delete(`${this.url}/delete-all`);
  }

  deleteBySelectedId(contactIds: any[]): Observable<any> {
    return this.http.post(`${this.url}/delete-selected`, { contactIds: contactIds });
  }


  addOrEditWhatsappcontact(whatsappcontact: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, whatsappcontact);
  }
  createContact(contactData: any): Observable<any> {

    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);
    }

    let params = new HttpParams();

    // if (vendorId != null) {
    //   params = params
    //     .set('vendorId', vendorId.toString());
    // }

    return this.http.post(`${this.url}/add-process`, contactData);
  }

  updateContact(contactData: any): Observable<any> {

    return this.http.post(`${this.url}/contacts/update-process`, {
      ...contactData
    });
  }
  searchContacts(searchQuery: string, page: number, size: number, sort: string): Observable<any> {

    const requestBody = {
      "searchQuery": searchQuery
    };

    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);
        this.whatsappVendorId = this.crmSettingsData.whatsappVendorId;

      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }


    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort);

    return this.http.post(`${this.url2}/contactReport/condition`, requestBody, { params });
  }
  // In your service
  whatsappcontactSearch(query: string, page: number, size: number): Observable<any> {
    const params = new HttpParams()
      .set('query', query || '')
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get(`${this.url}/filter`, { params });
  }

  uploadWhatsAppcontacts(payload: unknown): Observable<any> {
    return this.http.post<any>(`${this.url}/bulk/import`, payload);
  }

  uploadWhatsAppAssignedUser(payload: unknown): Observable<any> {
    return this.http.post<any>(`${this.url}/updateAssignedUser`, payload);
  }

  downloadContactTemplate(): Observable<any> {


    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }


    isLoading = new Subject<boolean>();
  
    show() {
      this.isLoading.next(true);
      
    }
  

}
